import axios from 'axios';

const api = axios.create({
  baseURL: 'https://devapi.vaheyeritsyan.com',
});

// api.interceptors.response.use(
//   response => response,
//   async error => {
//     if (error.response.status === 401) {
//       const token = localStorage.getItem('token');
//       if (!token) {
//         window.location.href = '/login';
//         return Promise.reject(error);
//       }
//     }
//     return Promise.reject(error);
//   }
// );

export default api;
